import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { QuoteForm } from "./QuoteForm";

export const QuoteModal = ({ open, onClose, presetType }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent
      className="max-w-xl max-h-[90vh] overflow-y-auto bg-[#FAF7F2] border-[#2E1065]/10 rounded-3xl"
      data-testid="quote-modal"
    >
      <DialogHeader>
        <DialogTitle className="font-display font-extrabold text-2xl text-[#2E1065]" data-testid="quote-modal-title">
          Request your custom quote
        </DialogTitle>
        <DialogDescription className="text-[#2E1065]/60">
          Free 3D proof · 5,000 pcs MOQ · reply within 24 hours.
        </DialogDescription>
      </DialogHeader>
      <QuoteForm presetType={presetType} compact idPrefix="modal-quote" onSuccess={onClose} />
    </DialogContent>
  </Dialog>
);
